





















import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator';

/**
 * Tarjeta genérica
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol>
 */
@Component
export default class Card extends Vue {
    @Prop({type: String, default: ''})
    public title: string

    @Prop({type: String, default: ''})
    public icon: string

    @Prop({type: String, default: 'auto'})
    public height: string

    @Prop({type: Boolean, default: false})
    public closable: boolean

    @Prop({type: String, default: 'auto'})
    public overflow: string

    @Prop({type: String, default: 'pa-0'})
    public paddingClass: string

    public get classes () {
        return [ this.paddingClass ]
    }
}
